import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function fmtHM(hours) {
  const total = Math.round((Number(hours) || 0) * 60);
  const abs = Math.abs(total);
  return `${total < 0 ? "-" : ""}${String(Math.floor(abs / 60)).padStart(2, "0")}h${String(abs % 60).padStart(2, "0")}`;
}

export const fmtMinHM = (minutes) => fmtHM((Number(minutes) || 0) / 60);
